import React from 'react';
import styles from '../../styles/errorPage.module.css';
import logoFr from "../../images/appGoFr.png";
import logoEn from "../../images/appGoEn.png";
import { GetLanguage } from '../../utils/language';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import Button from '@material-ui/core/Button';

class ErrorPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            logo: logoFr
        };
    }

    componentDidMount() {
        if (GetLanguage() == 'fr') {
            this.setState({ logo: logoFr });
        } else {
            this.setState({ logo: logoEn });
        }
    }

    handleButtonClick = () => {
        window.location.href = '';
    }

    render() {
        return <div className={styles.rootErrorPage}>
            <div className={styles.notFoundMessage}>
                <p style={{ textAlign: "left", marginBottom: "unset" }}>
                    <span className={styles.headerSpan}>{i18next.t('errorPage:content.title')}</span>
                </p>
                <p className={styles.contentWrapper}>
                    <span className={styles.contentSpan}>{i18next.t('errorPage:content.subtitle')}</span>
                </p>
            </div>
            <div>
                <Button
                    className={styles.punchButton}
                    variant="contained"
                    color="primary"
                    onClick={this.handleButtonClick}
                >
                    {i18next.t('errorPage:button.home')}
                </Button>
            </div>
        </div>;
    }
}
export default withNamespaces(['errorPage'], { wait: true })(ErrorPage);